import { inject,Injectable } from '@angular/core';
import { HttpService } from '@docpath/linces-angular-components/common';
import { Observable } from 'rxjs';

import { EndPoints } from '../../../../constants/end-points';



@Injectable({
    providedIn: 'root'
})
export class NotificationsConfigHttpService {

    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_CONFIGURATION}/${EndPoints.ENDPOINT_CONFIGURATION_FAILED_JOBS_NOTIFICATIONS}/${EndPoints.ENDPOINT_CONFIGURATION_FAILED_JOBS_NOTIFICATIONS_CONFIG}`;

    private readonly httpService = inject(HttpService);

    updateConfig(checkInterval: number): Observable<void> {
        return new Observable(observer => {
            this.httpService.put(undefined, {
                relativeUrl: this.relativeUrl,
                queryParameters: { failedJobsRefresh: checkInterval },
                loading: true,
                suscribe: () => {
                    observer.next();
                    observer.complete();
                },
                toast: 'failed-jobs.toast.update-check-interval-success'
            });
        });
    }
}
